import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Space } from 'antd';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { Loading } from 'components/atoms/loading';
import { ProductiveHeading03 } from 'components/styles';
import { RoutePaths } from 'constant';
import { logout } from 'utils/logout';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
const Message = styled.div`
  ${ProductiveHeading03};
`;
export const LogoutPage = ()=>{
    useEffect(()=>{
        logout(RoutePaths.goodbye);
    });
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs(Space, {
            align: "center",
            direction: "vertical",
            size: 24,
            children: [
                /*#__PURE__*/ _jsx(IconShell, {
                    size: "large",
                    icon: /*#__PURE__*/ _jsx(Loading, {
                        size: "large"
                    })
                }),
                /*#__PURE__*/ _jsx(Message, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "logging_out"
                    })
                })
            ]
        })
    });
};
